import { createContext, useContext, useMemo } from "react";
import { useParams } from "react-router";

import type { SiteHost } from "./host.server";

export type ChurchPlace = Pick<SiteHost, "mode" | "church">;

export function churchHref(place: ChurchPlace | string, path: string): string {
  return `${churchPrefix(place)}${path}` || "/";
}

export function churchPrefix(place: ChurchPlace | string): string {
  const where: ChurchPlace =
    typeof place === "string" ? { mode: "path", church: place } : place;
  return where.mode === "path" && where.church ? `/${where.church}` : "";
}

export const churchSlugOf = (place: ChurchPlace | string) =>
  typeof place === "string" ? place : place.church;

export type RootSite = ChurchPlace | null;

export const SiteContext = createContext<RootSite>(null);

export function useChurch(): ChurchPlace {
  const site = useContext(SiteContext);
  const handle = useParams().handle ?? "";
  return useMemo(
    () =>
      site && site.mode !== "path" ? site : { mode: "path", church: handle },
    [site, handle]
  );
}

export function useChurchHref() {
  const church = useChurch();
  return (path: string) => churchHref(church, path);
}
